import {
  DropdownButtonChevronDown,
  DropdownButtonChevronUp,
} from "@/assets/svg";
import React, { useState, useRef, useEffect } from "react";

interface DropdownButtonProps {
  label: string;
  disabled?: boolean;
  options: {
    icon?: React.ReactNode;
    label: string;
    onClick: () => void;
  }[];
  className?: string;
  buttonClassName?: string;
  menuClassName?: string;
  optionClassName?: string;
}

const DropdownButton: React.FC<DropdownButtonProps> = ({
  label,
  disabled,
  options,
  className = "",
  buttonClassName = "",
  menuClassName = "",
  optionClassName = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (callback: () => void) => {
    callback();
    setIsOpen(false);
  };

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <button
        className={`flex items-center gap-1 h-[34px] justify-between  text-white rounded-md px-4 py-2  ${buttonClassName} ${
          disabled
            ? "bg-[#9E9E9E] cursor-not-allowed"
            : "bg-[#73B5C5] cursor-pointer"
        }`}
        onClick={toggleDropdown}
        disabled={disabled}
      >
        <span className="text-sm">{label}</span>

        {isOpen ? <DropdownButtonChevronUp /> : <DropdownButtonChevronDown />}
      </button>

      {isOpen && (
        <div
          className={`absolute right-0 mt-1 z-10 bg-white border border-[#E0E0E0] rounded-[6px] shadow-lg overflow-hidden min-w-[150px] ${menuClassName}`}
        >
          <div className="py-1">
            {options.map((option, index) => (
              <button
                key={index}
                className={`w-full text-left text-[#1E1E1E] text-[14px] font-[500] px-4 py-2 flex items-center hover:bg-gray-100 cursor-pointer ${optionClassName}`}
                onClick={() => handleOptionClick(option.onClick)}
              >
                {option.icon && <span className="mr-2">{option.icon}</span>}
                {option.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownButton;
